import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default function AdditionalData({
  itKnowleadge = '',
  englishKnowleadge = '',
  codeKnowleadge = '',
  availableSat = false,
  availableTimeFrom,
  availableTimeTo,
  scholarship = '-',
  welcomeEmail,
  additionalNotes,
  onCollapsePanel = () => {},
}) {
  const translateLevel = (level) => {
    switch (level) {
      case 'high':
        return 'Alto';
      default:
        return 'No especificado';
    }
  };

  const translateBoolean = (boolean) => {
    return boolean ? 'Si' : 'No';
  };

  const translateScholarship = () => {
    switch (scholarship) {
      case 'beca':
        return 'Si';
      case 'mediabeca':
        return 'Media beca';
      default:
        return 'No especificado';
    }
  };

  const displayAvailableTime = () => {
    if (!availableTimeFrom && !availableTimeTo) return '-';
    return `${availableTimeFrom ? `Desde las ${availableTimeFrom}` : ''} ${
      availableTimeTo ? `Hasta las ${availableTimeTo}` : ''
    }`;
  };

  const hasNotes = Boolean(
    additionalNotes && String(additionalNotes).trim() !== ''
  );

  return (
    <div className="sd-card w-100">
      <div className="sd-panel-head">
        <div>
          <h3 className="sd-section-title">Datos adicionales</h3>
          <p className="sd-section-sub">Perfil académico y disponibilidad</p>
        </div>
        <Button
          variant="outline-secondary"
          size="sm"
          className="sd-hide-btn"
          onClick={onCollapsePanel}
          title="Ocultar panel"
        >
          <FontAwesomeIcon icon={faEyeSlash} />
        </Button>
      </div>
      <div className="mt-3 mb-2">
        {hasNotes ? (
          <div className="sd-notes-full" role="alert">
            <div className="sd-notes-header">
              <FontAwesomeIcon icon={faTriangleExclamation} />
              <strong>Notas adicionales — leer antes de gestionar</strong>
            </div>
            <p className="mt-1">{additionalNotes}</p>
          </div>
        ) : (
          <div className="sd-notes-empty">Sin notas adicionales</div>
        )}
      </div>
      <div>
        <div className="sd-field">
          <span className="sd-label">Computación</span>
          <span className="sd-value">{translateLevel(itKnowleadge)}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Programación</span>
          <span className="sd-value">{translateLevel(englishKnowleadge)}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Inglés</span>
          <span className="sd-value">{translateLevel(codeKnowleadge)}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Disponible sábados</span>
          <span className="sd-value">{translateBoolean(availableSat)}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Disponibilidad</span>
          <span className="sd-value sd-value-muted">
            {displayAvailableTime()}
          </span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Beca</span>
          <span className="sd-value">{translateScholarship()}</span>
        </div>
        <div className="sd-field">
          <span className="sd-label">Mail bienvenida</span>
          <span className="sd-value">{welcomeEmail}</span>
        </div>
      </div>
    </div>
  );
}
